import React from 'react';

export const TableHeader = ({ title, viewMode, isMobile }) => (
    <thead className="kt-datatable__head">
    <tr className="kt-datatable__row">
        <th colSpan={viewMode === 'view' ? 6 : 3} className="kt-datatable__cell kt-datatable__title" style={{textAlign: 'center'}}>
            {title}
        </th>
    </tr>
    {!isMobile && (
        <tr className="kt-datatable__row">
            <th width="200px" className="kt-datatable__cell"><span>Название</span></th>
            <th width="auto" className="kt-datatable__cell"></th>
            {viewMode === 'view' &&(
                <th style={{ textAlign: 'center' }} width="200px" className="kt-datatable__cell">
                    <span>Остаток (план.)</span>
                </th>
            )}
            <th style={{textAlign: 'center'}} width="200px" className="kt-datatable__cell">
                <span>{viewMode === 'input' ? 'Введенное количество' : 'Остаток (факт.)'}</span>
            </th>
            {viewMode === 'view' &&(
                <>
                    <th style={{ textAlign: 'center' }} width="200px" className="kt-datatable__cell">
                        <span>Излишки\недостача</span>
                    </th>
                    <th style={{ textAlign: 'center' }} width="200px" className="kt-datatable__cell">
                        <span>Сумма излишка\недостачи</span>
                    </th>
                </>
            )}
        </tr>
    )}
    </thead>
);